import { useEffect } from '@hfe/max';
const isWeb = true;
export function useThrottle(ms, callback, deps, needIsWeb) {
    let timeout = null;
    useEffect(() => {
        timeout && clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback && callback();
        }, ms);
        return () => {
            clearTimeout(timeout);
        };
    }, deps);
}
